import React from 'react';
import {
  TotalShow
} from '../../common/index'
import CollectionInfo from '../CollectionInfo'

interface Iprops {
  isInfo?: boolean
  title?: string
  subTitle?: string
  pClassName?: string
  setMode?: () => void
  location?: string
  total?: number | string
  hasOwen?: boolean
  isShowTotal?: boolean
}

function Empty(props: Iprops) {
  const {
    isInfo,
    setMode,
    pClassName,
    location,
    total,
    hasOwen,
    isShowTotal
  } = props

  return (
    <div className={`${pClassName}`}>
      {
        isInfo ?
          <CollectionInfo location={location} />
          :
          <>
            {
              isShowTotal && hasOwen ?
                <TotalShow
                  total={total}
                  lastTitle={hasOwen ? ' houses for you' : ' houses on other platforms'}
                /> : ''
            }
            <div>
              <span className=' text-lg font-semibold text-black select-none'>
              We can’t find any month2month properties for you right now. However, you can still send us a request, and our specialists will assist you to find a perfect one.
                <i className=' not-italic text-blue cursor-pointer' onClick={setMode}> Submit Request</i>
              </span>
            </div>
            {/* {
              isShowTotal && !hasOwen ?
                <TotalShow
                  pClassName='mb-0 mt-[12px]'
                  total={total}
                  lastTitle={hasOwen ? ' houses for you' : ' houses on other platforms'}
                /> : ''
            } */}
          </>
      }
    </div>
  );
}

export default Empty;
